import { errorMessageFor } from '@srichaitra/constants';

/**
 * The single error type every API call rejects with.
 *
 * Callers branch on `code` — a stable string from the backend — and render
 * `userMessage`, which is already translated through the shared message
 * catalogue. Nothing in the UI should ever display `message`: that is the
 * developer-facing text the server sent, useful in a log and wrong on a screen.
 */
export class ApiError extends Error {
  constructor(code, message, status = 0, requestId = null) {
    super(message || code);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
    this.requestId = requestId;
    this.userMessage = errorMessageFor(code);
  }

  /** The request never reached the server — no response, no status. */
  static network(message) {
    return new ApiError('NETWORK_ERROR', message, 0);
  }

  /** Something is wrong with this build's configuration, not with the server. */
  static config(message) {
    return new ApiError('CONFIG_ERROR', message, 0);
  }

  /** True when signing in again is the way out of this error. */
  get isAuthFailure() {
    return (
      this.status === 401 ||
      this.code === 'UNAUTHENTICATED' ||
      this.code === 'INVALID_TOKEN' ||
      this.code === 'INVALID_REFRESH_TOKEN'
    );
  }
}
